export default __webpack_public_path__ + "static/media/Strengths-Badge.d174b6ee.gif";